
import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild, NavigationExtras, CanLoad, Route } from '@angular/router';
import { AuthService } from './auth.service';
import { Permission } from '../models/permission.model';
import { AccountService } from './account.service';
import { LocalStoreManager } from './local-store-manager.service';
import { Observable, race, timer } from 'rxjs';
import { defaultIfEmpty, map, take } from 'rxjs/operators';


@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(private authService: AuthService, private accountService: AccountService, private router: Router,
    private localStorage: LocalStoreManager) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    
    let url: string = state.url;
    return this.checkLogin(url);

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): Observable<boolean> | boolean {
    let url = `/${route.path}`;
    return this.checkLogin(url);
  }

  checkLogin(url: string): Observable<boolean> | boolean {

    if (this.authService.isLoggedIn) {
      return true;
    }

    // A tab opened from a logged-in tab (e.g. a link with target="_blank") starts with an empty session: the
    // login (sessionStorage when "Remember me" is off) is copied over from the open tab a moment later via a
    // storage event. Wait briefly for that copy before sending the user to the login page.
    return race(this.localStorage.getInitEvent().pipe(defaultIfEmpty(null)), timer(800)).pipe(
      take(1),
      map(() => {
        if (this.authService.isLoggedIn) return true;
        this.authService.loginRedirectUrl = url;
        this.router.navigate(['/login']);
        return false;
      }));
  }


}
